import { Component } from '@angular/core';

import { I18NextModule } from 'angular-i18next';

import { MessageType } from '@hdms/shared/common-types';
import { MessageModule } from '@hdms/shared/ui-core';

@Component({
  selector: 'as-ftsw-generic-error',
  templateUrl: './generic-error.component.html',
  standalone: true,
  imports: [MessageModule, I18NextModule]
})
export class GenericErrorComponent {
  readonly messageType = MessageType;
}
